var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCuenca(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595.28 841.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #8b1a2b;\n      }\n\n      .st1 {\n        fill: #f6e9c0;\n      }\n\n      .st2 {\n        fill: #c26139;\n      }\n\n      .st3 {\n        fill: #fff;\n      }\n\n      .st4 {\n        stroke: #f6e9c0;\n      }\n\n      .st4, .st5 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .st6 {\n        fill: #1f519f;\n      }\n\n      .st7 {\n        fill: #e8c849;\n      }\n\n      .st8 {\n        fill: #298a8a;\n      }\n\n      .st5 {\n        stroke: #1d1d1b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "541.02 592.24 541.02 592.25 456.85 508.56 541.02 592.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "541.02 592.25 541.02 657.37 392.21 508.56 456.84 508.56 456.85 508.56 541.02 592.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "541.02 508.56 541.02 592.24 508.14 508.56 541.02 508.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M541.02,346.54v148.81h-38.45l-52.3-123.96h0c13.6-5.75,25.75-14.27,35.73-24.85h55.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M541.02,208.33v125h-44.34c11.55-16.96,18.31-37.45,18.31-59.52,0-16.92-3.97-32.91-11.02-47.09l37.05-18.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M541.02,184.52v23.81l-37.05,18.39h0c-8.59-17.28-21.77-31.87-37.94-42.2h75Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "541.02 592.24 456.85 508.56 508.14 508.56 541.02 592.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "541.02 657.37 392.21 657.37 392.21 509.42 541.02 657.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "541.02 657.37 392.21 509.42 392.21 508.56 541.02 657.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M514.99,273.81c0,22.07-6.76,42.56-18.31,59.52h-63.6l-24.85-58.98.88-.54,94.85-47.09h0c7.05,14.18,11.02,30.17,11.02,47.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M503.96,226.72l-94.85,47.09-.88.54,24.85,58.98h-40.87v-148.81h73.81c16.17,10.33,29.35,24.92,37.94,42.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M450.27,371.39l52.3,123.96h-59.01l-51.35-51.05v-65.97c5.49.89,11.14,1.36,16.9,1.36,14.61,0,28.51-2.96,41.16-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M439.79,346.54h46.21c-9.98,10.58-22.13,19.1-35.73,24.84l-10.48-24.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M450.27,371.38h0c-12.65,5.35-26.55,8.31-41.16,8.31-5.76,0-11.41-.47-16.9-1.36v-31.79h47.58l10.48,24.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "392.21 444.3 443.56 495.35 392.21 444.31 392.21 444.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "443.56 495.35 392.21 495.35 392.21 444.31 443.56 495.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "377.63 494.92 377.63 494.93 377.63 495.35 304.62 422.34 377.63 494.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.63,509.52v148.81h-58.81c-1.7-56.59-15.74-108.24-38.05-148.81h96.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M377.63,429.8v65.12l-73.01-72.58-1.39-1.39-74.38-74.38s.03-.02.04-.03h65l83.74,83.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.63,374.92v54.88l-83.74-83.26h38.32c12.31,13.03,27.89,22.93,45.42,28.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M377.63,346.54v28.38c-17.53-5.45-33.11-15.35-45.42-28.38h45.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M377.63,184.52v148.81h-56.09c-11.55-16.96-18.31-37.45-18.31-59.52,0-37.53,19.52-70.48,48.96-89.29h25.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M377.63,495.35h-105.29c-12.59-19.61-27.29-36.05-43.52-48.43h0v-99.94l74.41,73.97,1.39,1.39,73.01,73.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M228.82,184.52h123.37c-29.44,18.81-48.96,51.76-48.96,89.29,0,22.07,6.76,42.56,18.31,59.52h-40.95l-51.77-51.47h0v-97.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M318.82,658.33h-90v-148.81h51.95c22.31,40.57,36.35,92.22,38.05,148.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M303.23,420.95l-74.41-73.97v-.38l.03-.03,74.38,74.38Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "228.82 281.86 280.59 333.33 228.82 333.33 228.82 281.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M272.34,495.35h-43.52v-48.43c16.23,12.38,30.93,28.82,43.52,48.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "214.24 267.35 214.24 267.36 214.24 332.47 65.43 184.52 130.92 184.52 214.24 267.35"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    x: 65.43,
    y: 509.52,
    width: 148.81,
    height: 148.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M214.24,437.13v58.22H65.43v-31.65c25.98-26.99,57.32-42.76,91.07-42.76,20.34,0,39.8,5.72,57.74,16.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M214.24,346.54v90.59c-17.94-10.47-37.4-16.19-57.74-16.19-33.75,0-65.09,15.77-91.07,42.76v-117.16h148.81Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "214.24 332.47 214.24 333.33 65.43 333.33 65.43 184.52 214.24 332.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "214.24 184.52 214.24 267.35 130.92 184.52 214.24 184.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M63.22,466.04c.73-.79,1.47-1.57,2.21-2.34,25.98-26.99,57.32-42.76,91.07-42.76,20.34,0,39.8,5.72,57.74,16.19.42.24.83.48,1.24.73"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st5",
    x: 65.43,
    y: 509.52,
    width: 148.81,
    height: 148.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 304.62,
    y1: 422.34,
    x2: 377.63,
    y2: 495.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 228.85,
    y1: 346.57,
    x2: 303.23,
    y2: 420.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 541.02,
    y1: 657.37,
    x2: 392.21,
    y2: 508.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 541.02,
    y1: 592.25,
    x2: 456.85,
    y2: 508.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 508.14,
    y1: 508.56,
    x2: 541.02,
    y2: 592.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 450.27,
    y1: 371.38,
    x2: 439.79,
    y2: 346.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 502.57,
    y1: 495.35,
    x2: 450.27,
    y2: 371.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 392.21,
    y1: 444.31,
    x2: 443.56,
    y2: 495.35
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "391.26 508.48 392.21 509.42 541.02 657.37"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 377.63,
    y1: 494.93,
    x2: 378.12,
    y2: 495.41
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "228.62 346.78 228.82 346.98 303.23 420.95 304.62 422.34 377.63 494.92"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "65.43 184.52 214.24 332.47 215.17 333.39"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 541.02,
    y1: 592.25,
    x2: 541.76,
    y2: 592.98
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 456.85,
    y1: 508.56,
    x2: 541.02,
    y2: 592.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 456.31,
    y1: 508.03,
    x2: 456.84,
    y2: 508.56
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 443.57,
    y1: 495.35,
    x2: 444.17,
    y2: 495.95
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "391.46 443.55 392.21 444.3 443.56 495.35"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "293.89 346.54 377.63 429.8 378.59 430.75"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 293.26,
    y1: 345.92,
    x2: 293.88,
    y2: 346.54
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "228.82 281.86 280.59 333.33 281.47 334.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 227.72,
    y1: 280.76,
    x2: 228.82,
    y2: 281.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 214.24,
    y1: 267.36,
    x2: 214.88,
    y2: 267.99
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "129.89 183.5 130.92 184.52 214.24 267.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M332.2,346.54c-.22-.23-.44-.46-.66-.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M378.3,375.13c-.22-.07-.45-.14-.67-.21-17.53-5.45-33.11-15.35-45.42-28.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M486.89,345.6c-.29.32-.58.63-.89.94-9.98,10.58-22.13,19.1-35.73,24.84h0c-12.65,5.35-26.55,8.31-41.16,8.31-5.76,0-11.41-.47-16.9-1.36-.23-.03-.46-.07-.69-.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M496.67,333.33c-.1.16-.21.32-.32.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M503.97,226.72c7.05,14.18,11.02,30.17,11.02,47.09,0,22.07-6.76,42.56-18.31,59.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M465.85,184.41c.06.04.11.07.17.11,16.17,10.33,29.35,24.92,37.94,42.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M321.89,333.84c-.12-.17-.23-.34-.35-.51-11.55-16.96-18.31-37.45-18.31-59.52,0-37.53,19.52-70.48,48.96-89.29.29-.19.58-.37.87-.55"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "541.02 208.33 503.97 226.72 503.96 226.72 409.11 273.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M228.82,446.92c16.23,12.38,30.93,28.82,43.52,48.43.15.24.31.48.46.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M227.5,445.92l1.32.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M280.49,509.01c.09.17.19.34.28.51,22.31,40.57,36.35,92.22,38.05,148.81.02.53.04,1.07.05,1.61"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st4",
    points: "408.23 274.35 433.08 333.33 433.31 333.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "214.24 267.36 214.24 332.47 214.24 333.33 65.43 333.33 65.43 184.52 130.92 184.52 214.24 184.52 214.24 267.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 214.24,
    y1: 267.35,
    x2: 214.24,
    y2: 267.36
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "377.63 494.93 377.63 495.35 272.34 495.35 228.82 495.35 228.82 446.92 228.82 446.91 228.82 346.98 228.82 346.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 377.63,
    y1: 494.92,
    x2: 377.63,
    y2: 494.93
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "332.21 346.54 377.63 346.54 377.63 374.92 377.63 429.8 377.63 494.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 332.2,
    y1: 346.54,
    x2: 332.21,
    y2: 346.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 293.89,
    y1: 346.54,
    x2: 332.2,
    y2: 346.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 293.88,
    y1: 346.54,
    x2: 293.89,
    y2: 346.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 228.89,
    y1: 346.54,
    x2: 293.88,
    y2: 346.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 228.82,
    y1: 281.86,
    x2: 228.82,
    y2: 281.85
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "228.82 281.85 228.82 184.52 352.19 184.52 377.63 184.52 377.63 333.33 321.54 333.33 280.59 333.33 228.82 333.33 228.82 281.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "65.43 463.7 65.43 346.54 214.24 346.54 214.24 437.13 214.24 495.35 65.43 495.35 65.43 463.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "443.56 495.35 392.21 495.35 392.21 444.31 392.21 444.3 392.21 378.33 392.21 346.54 439.79 346.54 486 346.54 541.02 346.54 541.02 495.35 502.57 495.35 443.57 495.35"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 443.57,
    y1: 495.35,
    x2: 443.56,
    y2: 495.35
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "541.02 592.25 541.02 657.37 392.21 657.37 392.21 509.42 392.21 508.56 456.84 508.56"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 541.02,
    y1: 592.24,
    x2: 541.02,
    y2: 592.25
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "456.85 508.56 508.14 508.56 541.02 508.56 541.02 592.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 456.84,
    y1: 508.56,
    x2: 456.85,
    y2: 508.56
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "318.82 658.33 228.82 658.33 228.82 509.52 280.77 509.52 377.63 509.52 377.63 658.33 318.82 658.33"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "496.67 333.33 433.08 333.33 392.21 333.33 392.21 184.52 466.02 184.52 541.02 184.52 541.02 208.33 541.02 333.33 496.68 333.33"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 496.68,
    y1: 333.33,
    x2: 496.67,
    y2: 333.33
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuenca);
export default __webpack_public_path__ + "static/media/cuenca.f2735104dffa5aca0f9c19b4928e68e0.svg";
export { ForwardRef as ReactComponent };